
export class Messages {

    public PASSWORD_LENGTH = 8;

    SOCKET = {
        SUCCESS: {
            NEW_BID_ORDER: 'order is available for bidding',
            NEW_BID: 'New bid is placed for order',
            BID_STATUS: 'You have ',
            BID_STOPPED: 'is stopped/expired'
        }
    }

    ACCESSORIES = {
        VALIDATION: {
            ACCESSORY: 'Please fill the accessories name'
        },
        SUCCESS: {
            ACCESSORY_ADD: 'Accessory added Successfully'
        },
        ERROR: {}
    };

    BID_ORDERS = {
        SUCCESS: {
            BID: 'Bid Successful',
            SWITCH: 'Switched to Manual Bid',
            REQUEST: 'Bid Request Successful'
        },
        ERROR: {
            AMOUNT: 'Amount should be greater than 0',
            FLOOR_AMOUNT: 'Floor amount should be greater than 0',
            DECREMENT_VALUE: 'Decrement should be greater than 0',
            FLOOR_AMOUNT_GREATER: 'Floor amount should be less than Amount',
            NOT_INTEGER_AMT: 'Please enter an integer for the bid amount',
            NOT_INTEGER_FLOOR_AMT: 'Please enter an integer for the floor amount',
            NOT_INTEGER_DECREMENT_AMT: 'Please enter an integer for the decrement amount',
            EQUAL_AMOUNT: 'Amount should not be equal to the lowest bid',
        }
    }

    DELETE_BILL = {
        VALIDATION: {
            REASON_EMPTY: 'Please mention reason before deleting'
        },
        SUCCESS: {
            DELETE: 'Deleted Successfully'
        }
    }

    CREATE_BILL_MODAL = {
        VALIDATION: {
            BILLING_ADDRESS: 'Please fill the billing address'
        },
        SUCCESS: {
            BILL: 'Bill Created Successfully'
        }
    }

    DASHBOARD_MODALS = {
        ACCEPT_MODAL: {
            VALIDATION: {
                ACCEPT_NUMBER: 'Please fill accept number',
                noDecimal: 'Please enter a integer value'
            },
            ERROR: {
                ACCEPT_NUMBER: 'Accept number should be less than or equal to allocated number',
                TRY_AGAIN: 'Oops. Something went wrong. Please try again later'
            },
            SUCCESS: {
                ORDER_ACCEPT: 'Successfully Accepted',
                ORDER_REJECT: "Rejected Successfully"
            }
        },
        ASSIGN_MODAL: {
            VALIDATION: {
                VEHICLE_SELECT: 'Please select atleast one vehicle.',
                EXCEEDS_ACCEPT: 'Can not assign more than accepted'
            },
            SUCCESS: {
                ORDER_ASSIGN: 'Assigned Successfully',
            }
        }
    };

    DRIVERS = {
        DRIVER_ADD: {
            SUCCESS: {},
            VALIDATION: {
                LICENCE_EXPIRY: 'License expiry date should be greater than today',
                FILL_ALL: 'Please fill all mandatory details!',
                PASSWORD_LENGTH: `Password and Confirm Password length should be at least ${this.PASSWORD_LENGTH} characters`,
                PASSWORD_MATCH: 'Password and Confirm Password do not match!!',
            },
            ERROR: {
                MOBILE_NUMBER_VALID: 'Enter a valid mobile number'
            }
        },
        DIALOGDATA: {
            DETACHVEHICLE: 'Do you want to detach Vehicle?',
            OPTIN: 'Whatsapp opt in successful'
        }
    }


    ENTITY_DETAILS = {
        SUCCESS: {
            ENTITY_ADD: 'Successfully added entity',
            ENTITY_UPDATE: 'Successfully updated entity'
        },
        VALIDATION: {
            SELECT_FEATURE: 'Please select atleast one feature or sub-feature',
            FILL_ALL: 'Please fill all the details'
        },
        ERROR: {
            FEATURES_NOT_FOUND: 'No Features found'
        }
    }

    FAVORITE_LOCATION = {
        VALIDATION: {
            ADDRESS: 'Please select address',
            INVALID_ADDRESS: 'Invalid Address',
            ENTITY: 'Please fill entity name',
            CONTACT_NAME: 'Please fill contact name',
            CITY: 'Please fill the City name',
            MOBILE_NO: 'Please enter the mobile number'
        },
        SUCCESS: {
            LOCATION_ADD: 'Location added Successfully'
        }
    };


    LOAD_TYPE = {
        SUCCESS: {
            MATERIAL_ADD: 'Material added Successfully'
        },
        VALIDATION: {
            FILL_MATERIAL_NAME: 'Please fill the material name'
        }
    }

    LOGIN = {
        SUCCESS: {
            LOGIN_SUCCESS: 'Login Successful'
        },
        VALIDATION: {
            INVALID_EMAIL: 'Invalid Email',
            PASSWORD_LENGTH: `Password must me atleast ${this.PASSWORD_LENGTH} charecters long`,
            NO_EMPTY: 'Username and Password cannot be empty.',
        },
    };

    ORGANISATION = {
        SUCCESS: {
            ORGANISATION_ADD: 'Organisation Created Successfully'
        },
        VALIDATION: {
            FILL_ALL: 'Please fill all the fields'
        }
    };

    PERMITS = {
        SUCCESS: {
            PERMIT_ADD: 'Permit added Successfully'
        },
        VALIDATION: {
            FILL_PERMIT_NAME: 'Please fill the permit name'
        }
    };

    POST_SHIPMENT = {
        SUCCESS: {
            SHIPMENT: 'Shipment Booked Successfully'
        },
        VALIDATION: {
            LOCATION_PICKUP: 'Please select proper location at Pickup-',
            CORRECT_DATE_TIME_PICKUP: 'Please select proper date and time at Pickup-',
            LOCATION_DELIVERY: 'Please select proper location at Delivery-',
            CORRECT_DATE_TIME_DELIVERY: 'Please select proper date and time at Delivery-',
            INVALID_DATE_TIME_DELIVERY: 'Date and time should be greater than now for Delivery-',
            INVALID_DATE_TIME_PICKUP: 'Date and time should be greater than now for Pickup-',
            SELECT_MATERIAL: 'Please select atleast one material.',
            SELECT_VEHICLE_TYPE: 'Please select a vehicle type.',
            WEIGHT: 'Weight of the load cannot be 0',
            NUMBER_VEHICLE: 'No. of vehicles must be atleast one or more'
        }
    }

    SIGN_UP = {
        VALIDATION: {
            UNIT_DETIALS: 'Please fill Unit details',
            TAX_NUMBER: 'Please Enter Your Tax Number',
            MOBILE_NUMBER: 'Please Enter a Mobile Number',
            ACCOUNT_DETAILS: 'Please fill account details',
            FILL_DETAILS: 'Please fill your details'
        },
        ERROR: {
            INVALID_EMAIL: 'Invalid Email',
            INVALID_MOBILE_NO: 'Invalid user Mobile Number',
            PASSWORD_LENGTH: `Password must me atleast ${this.PASSWORD_LENGTH} charecters long`,
            PASSWORD_MATCH: 'Password and Confirm Password should be same!'
        }
    };

    USER_DETAILS = {
        VALIDATION: {
            SELECT_ROLE: 'Please select atleast one role or functionality',
            FILL_ALL: 'Please fill all details correctly'
        },
        ERROR: {
            RULES: 'No roles found',
            PASSWORD_LENGTH: `Password must me atleast ${this.PASSWORD_LENGTH} charecters long`,
            MOBILE_NUMBER: 'Enter the correct mobile number',
            EMAIL: 'Enter the Correct email id'
        },
        SUCCESS: {
            USER_ADD: 'User added successfully',
            editUser: 'User updated successfully'
        }
    };

    VEHICLES = {
        ADD_VEHICLE: {
            SUCCESS: {
                ADD: "Vehicle added Successfully"
            },
            VALIDATION: {
                CHASSIS_NUMBER: 'Chassis number should contain numbers only',
                VEHICLE_TYPE: 'Please fill vehicle type',
                ENGINE_NUMBER: 'Engine number should contain numbers only',
                MILAGE: 'Please fill mileage in kms',
                REGISTRATION_YEAR: 'Registration year should be in "YYYY" format',
                TANK_CAPCITY: 'Please fill tank capacity',
                REGISTRATION_NUMBER: 'Please fill valid registration number of the vehicle',
                ASSETS: "Please select the valid Asset"
            }
        },
        EDIT_VEHICLE: {
            SUCCESS: {
                EDIT: "Vehicle Saved"
            },
            VALIDATION: {
                VEHICLE_TYPE: 'Please fill vehicle type',
                ENGINE_NUMBER: 'Engine number should contain numbers only',
                MILAGE: 'Please fill mileage in kms',
                REGISTRATION_YEAR: 'Registration year should be in "YYYY" format',
                TANK_CAPCITY: 'Please fill tank capacity',
                REGISTRATION_NUMBER: 'Please fill valid registration number of the vehicle',
                ASSETS: "Please select the valid Asset"
            }
        },
        DIALOGDATA: {
            DETACHDRIVER: 'Do you want to detach Driver?'
        }
    };

    ATTACHDRIVER = {
        SUCCESS: {
            ATTACHSUCCESSFULL: 'Driver attached successfully'
        },
        DIALOGDATA: {
            OVERWRITE: 'Driver already attached, Do you want to overwrite?'
        }
    };
    ATTACHVEHICLE = {
        SUCCESS: {
            ATTACHSUCCESSFULL: 'Vehicle attached successfully'
        },
        DIALOGDATA: {
            OVERWRITE: 'Vehicle already attached, Do you want to overwrite?'
        }
    };
    CONFIRMATIONMODAL = {
        SUCCESS: {
            DETACH: 'Driver detached successfully',
            ATTACH: 'Vehicle attached successfully',
            UPLOAD: 'Upload successful'
        }
    };

    EDITDRIVER = {
        SUCCESS: {
            UPDATE: 'Driver details updated successfully'
        }
    };

    FORGOT_PASSWORD = {
        SUCCESS: {
            RESET_LINK: 'Password reset link has been sent to your email id '
        },
        ERROR: {
            EMAIL_ID: 'Enter a valid email id'
        }
    };

    RESET_PASSWORD = {
        VALIDATION: {
            MATCH: 'Password and confirm password do not match',
            PASSWORD_PROPERTES: 'Password should contain An uppercase letter, a lowercase letter, one digit, one special character, min length of 8',
            PASSWORD: 'Enter password'
        },
        SUCCESS: {
            PASSWORD: 'Password set successfully'
        }
    };
    SHIPMENT_MAP_DASHBOARD = {
        ERROR: {
            SHIPMENT_COMPLETED: 'Failed to mark shipment complete. Please try again later.',
        },
        SUCCESS: {
            SHIPMENT_COMPLETED: 'Shipment Completed Successfully'
        }
    };

    SHIPMENT_DETAILS = {
        FREIGHT: {
            VALIDATION: {
                UNIQUE_NUM: 'Please select Unique number type and enter the value.'
            },
            SUCCESS: {
                GENERATED: 'Invoices has been successfully generated.',
                APPROVED: 'Invoices has been successfully approved'
            }
        },
        EPODS: {
            SUCCESS: {
                UPLOAD_EPOD: "Are you sure to upload this E-POD?",
                REQUEST_EPOD: "Request to E-POD successfull."
            }
        },
        complete: 'Are you sure to mark this shipment as Complete?',
        container: 'Container No & Seal No added successfully',
        success: 'Successful',
        update: 'Updated successfully'
    };
    SHARE = {
        COPIED: 'URL copied to clipboard'
    };
    SEND_EMAIL = {
        SUCCESS: {
            EMAIL_SENT: 'Email Sent successfully'
        },
        ERROR: {
            EMAIL_ID: 'Enter a valid email id'
        }
    }


    ORDER_DASHBOARD = {
        SUCCESS: {
            SHIPMENT_COMPLETED: 'Shipment has been completed successfully'
        }
    };
    TAX = {
        validGst: 'Enter a valid GST number',
        allFields: 'Enter all the fields',
        panCr: 'Enter the PAN number',
        success: 'Successful',
        iban: 'Enter a valid IBAN',
        ifsc: 'Enter a valid IFSC number',
        pan: 'Enter a valid PAN'
    };
    reAssign = {
        oneDriver: "Please select only one driver",
        selectDriver: "Driver not selected",
        oneVehicle: "Please select only one vehicle",
        success: "Driver reassigned Successfully",
        assignSuccess: "Driver assigned successfully"
    };
    spotOnDriver = {
        success: 'Spot driver added successfully',
        validVehicle: 'Enter a valid vehicle no',
        allDetails: 'Please fill all the details'
    };
    unitSettings = {
        success: {
            sinCode: 'SIN code set successfully',
            counter: 'Counter set successfully',
            lrSeq: 'LR sequence set successfully',
            freight: 'Freight sequence set successfully',
            billSeq: 'Bill sequence set successfully',
            mobile: 'Mobile updated successfully',
            email: 'Email updated successfully'
        },
        validation: {
            mobile: 'Enter a valid mobile number',
            email: 'Enter a valid email'
        }
    }
    PARALLEL = {
        SUCCESS: {
            ALLOCATION: 'Parallel allocation accepted successfully'
        }
    }
}
